import can from 'ember-can/helpers/can';
import RouteTemplate from 'ember-route-template';
import QuestionnairesList from 'garaje/components/visitors/questionnaires/list';

import type VisitorsQuestionnairesIndexController from './controller';
import type { VisitorsQuestionnairesIndexRouteModel } from './route';

interface Signature {
  Args: {
    controller: VisitorsQuestionnairesIndexController;
    model: VisitorsQuestionnairesIndexRouteModel;
  };
}

export default RouteTemplate<Signature>(
  <template>
    <QuestionnairesList
      @canCreateQuestionnaires={{can "create questionnaires"}}
      @canDeleteQuestionnaires={{can "delete questionnaires"}}
      @canUpdateQuestionnaires={{can "update questionnaires"}}
      @createRoute="visitors.questionnaires.create"
      @flowFilter={{@controller.flow}}
      @flows={{@model.flows}}
      @location={{@model.location}}
      @showRoute="visitors.questionnaires.show"
      @sort={{@controller.sort}}
      @titleFilter={{@controller.title}}
      @updateQueryParam={{@controller.updateQueryParam}}
    />
  </template>,
);
